import { ExportConfiguration } from '../export/exportConfiguration';
import { ExportType } from '../export/export';
import { translate } from '../translation/Translator';
import { TranslationKey } from '../translation/TranslationKey';
import { TranslationLanguage } from '../translation/translation';

export const ProductTransactionExportConfigurationField = {
  type: 'type',
  status: 'status',

  sourceStockLocationName: 'sourceStockLocationName',
  destinationStockLocationName: 'destinationStockLocationName',

  sourceBinName: 'sourceBinName',
  destinationBinName: 'destinationBinName',

  sourceContainerIdentifier: 'sourceContainerIdentifier',
  destinationContainerIdentifier: 'destinationContainerIdentifier',

  productName: 'productName',
  productNumber: 'productNumber',

  serialNumber: 'serialNumber',
  lpn: 'lpn',

  lotNumber: 'lotNumber',
  expirationDate: 'expirationDate',

  parentType: 'parentType',
  parent: 'parent',

  quantity: 'quantity',

  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  processedAt: 'processedAt',
  createdBy: 'createdBy',
  updatedBy: 'updatedBy',
  processedBy: 'processedBy',

  globalTradeItemNumber: 'globalTradeItemNumber',

  unitOfMeasure: 'unitOfMeasure',
} as const;

export type ProductTransactionExportConfigurationField =
  (typeof ProductTransactionExportConfigurationField)[keyof typeof ProductTransactionExportConfigurationField];

export class ProductTransactionExportConfiguration extends ExportConfiguration<ProductTransactionExportConfigurationField> {
  static default(companyId: string, language?: TranslationLanguage) {
    return new ProductTransactionExportConfiguration({
      companyId,
      name: '',
      type: ExportType.xlsx,
      filename: 'ventory_product_transactions_${TIMESTAMP}',
      mapping: new Map([
        [
          ProductTransactionExportConfigurationField.type,
          { value: translate({ key: TranslationKey.type, language }), index: 0 },
        ],
        [
          ProductTransactionExportConfigurationField.productName,
          { value: translate({ key: TranslationKey.productName, language }), index: 1 },
        ],
        [
          ProductTransactionExportConfigurationField.productNumber,
          { value: translate({ key: TranslationKey.number, language }), index: 2 },
        ],
        [
          ProductTransactionExportConfigurationField.sourceStockLocationName,
          { value: translate({ key: TranslationKey.sourceStockLocationName, language }), index: 3 },
        ],
        [
          ProductTransactionExportConfigurationField.destinationStockLocationName,
          { value: translate({ key: TranslationKey.destinationStockLocationName, language }), index: 4 },
        ],
        [
          ProductTransactionExportConfigurationField.sourceBinName,
          { value: translate({ key: TranslationKey.sourceBin, language }), index: 5 },
        ],
        [
          ProductTransactionExportConfigurationField.destinationBinName,
          { value: translate({ key: TranslationKey.destinationBin, language }), index: 6 },
        ],
        [
          ProductTransactionExportConfigurationField.quantity,
          { value: translate({ key: TranslationKey.quantity, language }), index: 7 },
        ],
        [
          ProductTransactionExportConfigurationField.serialNumber,
          { value: translate({ key: TranslationKey.serial, language }), index: 8 },
        ],
        [
          ProductTransactionExportConfigurationField.status,
          { value: translate({ key: TranslationKey.status, language }), index: 9 },
        ],
        [
          ProductTransactionExportConfigurationField.processedAt,
          { value: translate({ key: TranslationKey.processedAt, language }), index: 10 },
        ],
        [
          ProductTransactionExportConfigurationField.processedBy,
          { value: translate({ key: TranslationKey.processedBy, language }), index: 11 },
        ],
      ]),
    });
  }
}
